"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollBarWidth = getScrollBarWidth;
exports.calcOffset = calcOffset;

function getScrollBarWidth() {
  const scrollDiv = document.createElement('div');
  scrollDiv.className = 'react-timekeeper-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  const width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return width;
}

function calcOffset(el) {
  const style = window.getComputedStyle(el, null);
  return function (clientX, clientY) {
    const borderLeftWidth = parseInt(style.borderLeftWidth, 10) || 0;
    const borderTopWidth = parseInt(style.borderTopWidth, 10) || 0;
    const rect = el.getBoundingClientRect();
    return {
      offsetX: clientX - borderLeftWidth - rect.left,
      offsetY: clientY - borderTopWidth - rect.top
    };
  };
}